import { ElementSource } from "chq";
import { isSubtitleText } from "../utils";

const updateSubtitlesSectionsPositionByRange = (
  jsonElements: ElementSource[],
  timeAdjustment: number,
  currentElementId: string,
  startTime: number,
  endTime: number
): ElementSource[] => (
  jsonElements.map((element: ElementSource) => {
    if (!isSubtitleText(element.name)) return element;

    const [_prefix, refId] = element.name.split("REF=", 2);
    if (refId !== currentElementId) return element;

    return {
      ...element,
      time: Math.max(element.time + timeAdjustment, 0)
    };
  })
);

export default updateSubtitlesSectionsPositionByRange;
